export const styles = {
	container: {
		paddingTop: '3rem',
		paddingBottom: '3rem',
		paddingX: '3rem',
	},
	circularProgressIcon: {
		color: 'white',
	},
	genAiUnSelectableContent: {
		'&:hover': {
			backgroundColor: 'transparent',
		},
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'center',
		padding: '1.4rem',
		width: '100%',
	},
	genAiPreviewContent: {
		'&:hover': {
			backgroundColor: 'background.hover',
			borderColor: 'secondary.main',
			cursor: 'pointer',
		},
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'center',
		padding: '1.4rem',
		width: '100%',
	},
	genAiPreviewImg: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		whiteSpace: 'normal',
	},
	genAiPreviewText: {
		color: 'secondary.main',
		fontWeight: 'fontWeightRegular',
		textAlign: 'center',
		textDecoration: 'underline',
		textUnderlineOffset: '.22em',
	},
	genAiResponseContainer: {
		borderColor: 'secondary.main',
		border: '1px solid',
		display: 'flex',
		height: '27rem',
		justifyContent: 'center',
		marginTop: '.5rem',
		overflow: 'auto',
		width: '100%',
	},
	genAiResponseContent: {
		padding: '1.4rem',
		width: '100%',
	},
	ideaTextField: {
		marginBottom: '2rem',
		width: '100%',
	},
	newResponseButton: {
		disabled: {
			opacity: 0,
		},
	},
	scenarioScrollContainer: {
		width: 'auto',
		height: '45rem',
		overflowX: 'auto',
		whiteSpace: 'nowrap',
	},
	sectionHeader: {
		display: 'flex',
		flexDirection: 'column',
		gap: '0.6rem',
	},
	sectionHeaderContent: {
		color: 'primary.main',
		display: 'flex',
		flexDirection: 'row',
		gap: '1.2rem',
	},
	sectionHeaders: {
		display: 'flex',
		pb: '2.4rem',
	},
	sectionText: {
		color: 'text.secondary',
		fontStyle: 'italic',
		maxHeight: '27rem',
		whiteSpace: 'pre-wrap',
		padding: '1.4rem',
		alignItems: 'center',
	},
	pasteButton: {
		padding: '0',
	},
	submitButton: {
		'&:disabled': {
			backgroundColor: 'primary.disabled',
			color: '#FFF',
		},
		'&:hover': {
			backgroundColor: 'primary.main',
			color: '#FFF',
		},
		backgroundColor: 'primary.main',
		borderRadius: 0,
		color: '#FFF',
		width: '15.5rem',
	},
	submitContainer: {
		alignItems: 'start',
		display: 'flex',
		flexDirection: 'row',
		gap: '1.4rem',
		paddingBottom: '1.4rem',
	},
}
